import { useI18n } from '@cascade/react/i18n';
import { Drawer } from '@cascade/ui-library';
import clsx from 'clsx';
import { Navigation } from './navigation/index.ts';
import classes from './Sidebar.module.scss';
import { UserArea } from './user-area/index.ts';
import { Header } from '#layout/app/header/index.ts';
import { useLayout } from '#layout/Layout.context.ts';

export const Sidebar = () => {
  const { translate } = useI18n();
  const { isRegular, isSidebarOpen, isRail, closeSidebar } = useLayout();

  const label = translate('navigation.title');

  const navigation = (
    <nav
      className={clsx(classes.sidebar, {
        [classes.rail]: isRegular,
        [classes.collapsed]: isRail,
      })}
      aria-label={label}
    >
      {isRegular ? <Header /> : null}
      <Navigation />
      <UserArea />
    </nav>
  );

  if (isRegular) {
    return navigation;
  }

  return (
    <Drawer
      open={isSidebarOpen}
      side='left'
      aria-label={label}
      closeLabel={translate('navigation.close')}
      contentClassName={classes['drawer-content']}
      onClose={closeSidebar}
    >
      {navigation}
    </Drawer>
  );
};
